<div
  class="card card-custom"
  [ngClass]="{
    'card-body-progress': viewLoading,
    'card-body-progress-overlay': loadingAfterSubmit
  }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>{{ getTitle() }}</h3>
    </div>
  </div>
  <!--begin::Form-->
  <form class="form" [formGroup]="entitySelectForm" autocomplete="off">
    <div class="card-body">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <div class="row">
        <div class="col kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>{{ 'TASK.ENTITY_TYPE' | translate }}</mat-label>
            <mat-select
              formControlName="entityType"
              (selectionChange)="entityTypeBS.next($event.value)"
            >
              <mat-option
                *ngIf="data.source === 'TASK' || data.source === 'COMMUNICATION-RECIPIENT'"
                value="DOCTOR"
                >{{ 'MENU.DOCTOR' | translate }}</mat-option
              >
              <mat-option
                *ngIf="data.source === 'TASK' || data.source === 'COMMUNICATION-RELATED'"
                value="PATIENT"
                >{{ 'MENU.PATIENT' | translate }}</mat-option
              >
              <mat-option
                *ngIf="data.source === 'TASK' || data.source === 'COMMUNICATION-RECIPIENT'"
                value="FACILITY"
                >{{ 'MENU.FACILITY' | translate }}</mat-option
              >
              <mat-option *ngIf="data.source === 'COMMUNICATION-RECIPIENT'" value="PHARMACY">{{
                'MENU.PHARMACY' | translate
              }}</mat-option>
              <mat-option
                *ngIf="
                  data.source === 'COMMUNICATION-RECIPIENT' ||
                  data.source === 'COMMUNICATION-RELATED'
                "
                value="CONTACT"
                >{{ 'MENU.CONTACT' | translate }}</mat-option
              >
              <mat-option *ngIf="data.source === 'COMMUNICATION-RECIPIENT'" value="INSURANCE">{{
                'MENU.INSURANCE' | translate
              }}</mat-option>
              <mat-option *ngIf="data.source === 'TASK'" value="CLIENT">{{
                'MENU.CLIENT' | translate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="px-0">
        <kt-general-autocomplete
          [appearance]="'fill'"
          [label]="'Entity'"
          [loadItemsFunction]="entityAutocompleteCall"
          [optionSearchFields]="entitySearchFields"
          [optionHeader]="stringUtils.getEntityHeader(entityTypeBS | async)"
          [optionFormatter]="
            (entityTypeBS | async)?.localeCompare('INSURANCE') === 0
              ? stringUtils.autocompleteEntityFormatter
              : stringUtils.getEntityFormatter.bind(stringUtils, entityTypeBS | async)
          "
          [chipOptionFormatter]="stringUtils.autocompleteEntityFormatter"
          [valueFormatter]="stringUtils.autocompleteEntityFormatter"
          [required]="false"
          [readOnly]="false"
          [control]="entitySelectForm.get('entities')"
          [change]="onEntityChange.bind(this)"
          [dataPath]="'data'"
          [placeholder]="'Select Entities'"
          [formatNewObjectFn]="formatNewEntityFn"
          [chipList]="true"
          [filterResultsFunction]="data.source === 'COMMUNICATION-RECIPIENT' ? filterFn : null"
          [objects]="entitySelectForm.get('entities').value"
          #entityAutocomplete
        ></kt-general-autocomplete>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            cdkFocusInitial
            (click)="onNoClick()"
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="submit"
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
  <!--end::Form-->
</div>
